<template>
  <div class="container-fluid mt-5">
    <ValidationObserver ref="generalInformationForm">
      <SectionTitle
        :has-line="true"
        content="Información General de la Discusión"
      />

      <div class="row d-flex justify-content-start">
        <div class="col-md-7 col-sm-12 info">
          <div class="row">
            <div class="col-md-6 col-sm-12">
              <ValidationProvider v-slot="{ errors }" rules="required">
                <custom-date-picker
                  v-model="value.academicyearfordate"
                  label="Fecha:"
                  :max-date="disabledDatesAfter"
                  :error="errors[0]"
                  :custom-error-msg="errorMsgs['fecha']"
                  class="custom-datetime-picker-container"
                  :disabled="isSubmitted"
                  @input="onSelectedDate"
                />
              </ValidationProvider>
            </div>
            <div class="col-md-6 col-sm-12">
              <label class="text-gray font-weight-light font-15 mb-3">
                Año Académico:
              </label>

              <p>
                <label>{{ this.value.academicYearDesc }}</label>
              </p>
            </div>
          </div>
        </div>
      </div>
    </ValidationObserver>
  </div>
</template>

<style scoped src="@/assets/css/component/panel-simple.css"></style>

<script>
import CustomDatePicker from 'custom-date-picker';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import alertMixin from '@/mixin/alert.mixin';
import SectionTitle from 'SectionTitle';
import CustomTextArea from 'CustomTextArea';
import academicYearService from '@/services/academicyear';

export default {
  name: 'GeneralInformation',
  mixins: [alertMixin],
  components: {
    CustomDatePicker,
    ValidationProvider,
    ValidationObserver,
    SectionTitle,
    CustomTextArea,
  },
  props: {
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      disabledDatesAfter: new Date(Date.now()),
      errorMsgs: {
        fecha: 'La fecha es requerida.',
        comentario: 'El comentario es requerido.',
      },
      value: {
        evaluationDate: null,
        academicYearId: null,
        academicYearDesc: null,
        academicYear: null,
        impedimentChangeFlag: false,
        comment: null,
        academicyearfordate: null,
      },
    };
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    async onSelectedDate(date) {
      if (date) {
        await academicYearService
          .getAcademicYearForDate(date)
          .then((response) => {
            this.value.academicYearId = response.data.id;
            this.value.academicYearDesc = response.data.description;
            this.value.evaluationDate = this.academicyearfordate;
            this.value.academicYear = response.data.year;

            this.$emit('change-academic-year', response.data, date);
            this.$emit('change-evaluation-date', date);
          });
      }
    },
    async onChangeComment() {
      this.$emit('change-comment', this.value.comment);
    },
  },
};
</script>

<style scoped>
.custom-panel-row-without-selector {
  background: #fafbfa 0% 0% no-repeat padding-box;
}
</style>
